import React from 'react';
import { useAureliaI18n } from '../../../react-hooks/useAureliaI18n';
import useChoice from '../../../react-hooks/useChoice';
import { formatJoin } from './helpers/cellFormatters';
import { getChoiceLabel } from './helpers/getChoiceLabel';

const DayOfWeekDisplay = ({ dayOfWeek, choices }) => {
    if (typeof dayOfWeek === 'object' && dayOfWeek !== null) {
        const days = Array.isArray(dayOfWeek) ? dayOfWeek : Object.values(dayOfWeek);

        return (
            <>
                {days.map((day, index) => (
                    <React.Fragment key={index}>
                        {index > 0 && ','}
                        {getChoiceLabel(choices, day)}
                    </React.Fragment>
                ))}
            </>
        );
    }

    return <>{getChoiceLabel(choices, dayOfWeek)}</>;
};

const DateInterval = ({ params }) => {
    const value = params?.value;
    const { t } = useAureliaI18n();
    const dayOfWeekChoices = useChoice({ type: 'dayOfWeek', getAll: true });

    if (!value?.type) {
        return <></>;
    }

    return (
        <>
            {value.type === 'none' && t('base.date-interval.none')}
            {value.type === 'daily' && t('base.date-interval.daily')}
            {value.type === 'yearly' && (
                <>
                    {t('base.date-interval.yearly')} {formatJoin(value.daysOfMonth)} /{' '}
                    {formatJoin(value.months)}
                </>
            )}
            {value.type === 'monthly' && (
                <>
                    {t('base.date-interval.monthly')} {formatJoin(value.daysOfMonth)}
                </>
            )}
            {value.type === 'weekly' && (
                <>
                    {t('base.date-interval.weekly')}{' '}
                    <DayOfWeekDisplay
                        dayOfWeek={value.dayOfWeek}
                        choices={dayOfWeekChoices}
                    />
                </>
            )}
            {value.hours != null && (
                <>
                    <br />
                    {t('base.date-interval.hours.label')}:
                    {value.hours.map((entry, index) => (
                        <React.Fragment key={index}>
                            {entry}
                            {index < value.hours.length - 1 && (
                                <span className="separator">, </span>
                            )}
                        </React.Fragment>
                    ))}
                </>
            )}
        </>
    );
};

export default DateInterval;
